import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {catchError, Observable, of, shareReplay} from 'rxjs';
import {ILegalEntityOption} from '../interfaces/erp-outbound-panel.interface';

@Injectable({
  providedIn: 'root'
})
export class ErpOutboundLookupService {
  private readonly http = inject(HttpClient);

  private legalEntities$?: Observable<ILegalEntityOption[]>;

  /** Cached list of legal entities used to populate the Legal Entity filter dropdown. */
  public getLegalEntities(): Observable<ILegalEntityOption[]> {
    this.legalEntities$ ??= this.http.get<ILegalEntityOption[]>('dbov2/legal-entity/many')
      .pipe(
        catchError(() => of<ILegalEntityOption[]>([])),
        shareReplay(1),
      );
    return this.legalEntities$;
  }
}
